module.exports = __webpack_public_path__ + "images/MongoDB_Inc-edcd65.png";